// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

M.Collection = M.Collection || {};
M.Collection.ProductDetails = M.Collection.ProductDetails || {};

/**
 * @class M.Collection.ProductDetails.Shape
 *
 * Used by by the M.View.ProductDetails.ShapePicker
 */
M.Collection.ProductDetails.Shapes = Backbone.Collection.extend({
  model: M.Model.ProductDetails.Shape,

  /**
   * @param shape {M.Model.ProductDetails.Shape} The Shape model to select.
   */
  select: function(shape) {
    this.selected = shape;
  },

  /**
   * Return the selected shape object.
   *
   * @return this.selected {M.Model.ProductDetails.Shape} The selected Shape model.
   */
  getSelected: function() {
    return this.selected;
  }
});
